import { SelectItem } from 'components/inputs/select/select';

import { KEYS } from './keys';

const tz = (offset: string): SelectItem => ({
  key: `${KEYS.TIMEZONE_PREFIX}${offset}`,
  label: `${KEYS.TIMEZONE_PREFIX}${offset}`,
});

export const TIMEZONE_OPTIONS: SelectItem[] = [
  tz('-12:00'),
  tz('-11:00'),
  tz('-10:00'),
  tz('-09:00'),
  tz('-08:00'),
  tz('-07:00'),
  tz('-06:00'),
  tz('-05:00'),
  tz('-04:00'),
  tz('-03:00'),
  tz('-02:00'),
  tz('-01:00'),
  tz('+00:00'),
  tz('+01:00'),
  tz('+02:00'),
  tz('+03:00'),
  tz('+04:00'),
  tz('+05:00'),
  tz('+06:00'),
  tz('+07:00'),
  tz('+08:00'),
  tz('+09:00'),
  tz('+10:00'),
  tz('+11:00'),
  tz('+12:00'),
];
